import React from 'react';
import { AlignmentTypes, ICustomizableElement } from '@insurancemenu/imenu-components-lib/dist/types';
import { Tooltip } from '@insurancemenu/imenu-components-lib';
import { AccessTagStyled } from './styles';

interface Props extends ICustomizableElement {
  size?: 'small' | 'large';
  accessLimitation?: string;
}

export const AccessTag: React.FC<Props> = ({ className, size = 'small', accessLimitation = 'Management Only' }) => {
  return (
    <Tooltip label={accessLimitation} alignment={AlignmentTypes.BOTTOM_CENTER}>
      <AccessTagStyled className={className} $size={size}>
        Limited Access
      </AccessTagStyled>
    </Tooltip>
  );
};
